<template lang="pug">
  .component-driver-profile(v-if="driver !== null")
    .action-bar
      h2 Driver Profile
    .driver-profile.tabs-inner-content
      .row
        .column
          driver(:type="'driver-data'", :item="driver")
      hr
      .row
        .column
          h2 Groups
          DriverGroup(v-for="group in driver.groups", :item="group", :driver="driver", @toggleSupervisor="toggleSupervisor")

</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import Driver from 'components/backoffice/Driver'
  import ActionButton from '../../structure/ui/ActionButton'
  import DriverGroup from '../DriverGroup'
  import MaggieHelper from '../../../maggieHelper'

  export default {
    name: 'DriverProfile',
    components: {
      DriverGroup,
      ActionButton,
      Driver
    },
    data() {
      return {
        driver: null,
        diffs: null,
        driver_status : null
      }
    },
    created() {
      KeplerBackofficeSdk.drivers.select(this.$route.params.id).get((data) => {
        this.driver = data
        this.driver_status = this.driver.status
      })
    },
    methods: {
      toggleSupervisor(val) {
        KeplerBackofficeSdk.driverGroups.select(this.$route.params.id).toggleSupervisor({
          group_id: val.id,
          supervisor: val.supervisor
        }, () => {
          MaggieHelper.notification('Supervisor', 'Driver updated')
        })
      },
    }
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .driver-profile
    margin: 10px
  .border-class
    border-color: red
    color: red

</style>



// WEBPACK FOOTER //
// DriverProfile.vue?4bbeb40e